import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { useAccountStore as useAccountStoreSource } from "./Account";
import KHStore from "./KH";
import LanguageStore from "./Language";
import LookupsStore from "./Lookups";
import RegisterCompanyStore from "./register";
import SupplierStore from "./Supplier";
import TicketsStore from "./Ttickets";

const storageVersion = import.meta.env.VITE_STORAGE_VERSION;

export const useRegistrationStore = create(RegisterCompanyStore);
export const useSupplierStore = create(SupplierStore);
export const useLookupsStore = create(LookupsStore);
export const useTicketsStore = create(TicketsStore);
export const useKHStore = create(KHStore);
export const useAccountStore = useAccountStoreSource;

export const useLanguageStore = create(
  persist<{ Language: "en" | "ar"; setLanguage: (string) => void }>(LanguageStore, {
    name: "Language",
    storage: createJSONStorage(() => localStorage),
    version: storageVersion,
  }),
);
